import React, { memo } from 'react';
import { ControlsPdfQuery } from 'src/graphql/_generated';
import { ActionsConf, TocItem } from '../../types';
import { FooterStartComponent, HeaderEndComponent, RmpPage } from '../../comps';
import _ from 'lodash';
import { ColorSet } from 'src/redux/reducers/theme';

type ControlPdf = ControlsPdfQuery['controls'][number];

interface RmpRenderProps {
  controls: ControlPdf[];
  onDone: (data: TocItem[]) => void;
  colors: ColorSet;
  includesActions: ActionsConf;
}

export const RmpRender: React.FC<RmpRenderProps> = memo(
  ({ controls, onDone, colors, includesActions }) => {
    if (!controls.length) {
      onDone([]);
      return null;
    }
    const list: { [key: string]: TocItem } = {};

    const onRender = (pageNumber: number, idx: number, title: string) => {
      list[idx] = { pageNumber: pageNumber, title };

      if (idx === controls.length - 1) {
        const outputArray = Object.keys(list).map((key) => list[key]);
        onDone(outputArray);
      }
    };

    return (
      <>
        {controls.map((el, idx) => {
          const scenarios =
            el.riskManagementPlans?.map((rmp) => rmp.scenario).filter((s): s is NonNullable<typeof s> => Boolean(s)) ||
            [];
          return (
            <RmpPage
              control={el}
              scenarios={scenarios}
              onRender={(pageNumber) => onRender(pageNumber, idx, el.name)}
              endComponent={<HeaderEndComponent idx={idx + 1} title="CONTROL" />}
              footerComponent={<FooterStartComponent title={`Risk management plan / ${el.name}`} />}
              colors={colors}
              includesActions={includesActions}
            />
          );
        })}
      </>
    );
  },
  (prevProps, nextProps) => _.isEqual(prevProps, nextProps),
);
